import { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { Translatable } from "app/pages/sales-intelligence/types";

export const SELECTION_MODAL_TITLE: Record<AppsSourceType, Translatable> = {
    [AppsSourceType.GoogleStore]: {
        key: "si.find_apps.column-picker.title.googleStore",
    },
    [AppsSourceType.AppleStore]: {
        key: "si.find_apps.column-picker.title.appleStore",
    },
};
